import React from "react";
import { Link } from "react-router-dom";
import { FaInfoCircle } from "react-icons/fa";
import NewBookingCalendar from "../../Dashboard/NewBookingCalendar";

// The crew availability calendar, inline in the Schedule step (it used to open in a modal).
// Tapping a free slot assigns that crew member; the job's time is split between everyone
// selected. All state lives in the stepper - this only draws it.
function AvailabilityGrid({ b }) {
  const {
    isSportsService,
    isCarService,
    isSalonService,
    initialAppointments,
    providerSelected,
    crewCount,
    serviceDuration,
    durationPerCleaner,
    poolProfessionalIds,
    poolFilterActive,
    chosenResource,
    setShowAllCrew,
    appointments,
    dateSelect,
    datesSet,
    editable,
    timeRange,
    handleAppointmentClick
  } = b;

  const person = isSportsService ? "sports member" : isCarService || isSalonService ? "service provider" : "crew";

  if (initialAppointments.length === 0) {
    return (
      <div className="bstep-empty">
        <div className="mb-2">No {person} is available for this service on this day.</div>
        <Link to="/providers/add">Add {person} for this service</Link>
      </div>
    );
  }

  return (
    <>
      <div className="bstep-grid-notes">
        {providerSelected?.length > 0 && (
          <div className="bstep-note bstep-note-selected">
            <div className="bstep-note-title">Selection</div>
            {[
              { label: "Crew Selected", value: crewCount },
              { label: "Service Duration", value: `${serviceDuration} hrs` },
              { label: "Duration Per Cleaner", value: `${durationPerCleaner} mins` }
            ].map(({ label, value }) => (
              <div key={label} className="bstep-note-row">
                <span>{label}</span>
                <strong>{value}</strong>
              </div>
            ))}
          </div>
        )}

        <div className="bstep-note bstep-note-help">
          <div className="bstep-note-title">
            <FaInfoCircle size={12} /> How to use
          </div>
          <ul>
            {[
              "Tap an available slot to assign it to the crew.",
              "Tap a selected slot again to unassign it.",
              "Red slots are already blocked and unavailable.",
              "If all slots for a crew are unavailable, the crew is on leave for that day.",
              "Use ‹ › to look at another day - the booking moves to a day when you tap a slot there."
            ].map((text) => (
              <li key={text}>{text}</li>
            ))}
          </ul>
        </div>
      </div>

      {poolProfessionalIds.length > 0 && (
        <div className="d-flex align-items-center justify-content-between mb-2" style={{ fontSize: "13px" }}>
          <span className="text-muted">
            {poolFilterActive ? `Showing the crew mapped to ${chosenResource?.name}.` : "Showing everyone."}
          </span>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => setShowAllCrew((v) => !v)}>
            {poolFilterActive ? "Show everyone" : `Only ${chosenResource?.name}'s crew`}
          </button>
        </div>
      )}

      <div className="bstep-calendar bookingCalender removeHeader">
        <NewBookingCalendar
          events={appointments}
          date={dateSelect}
          datesSet={datesSet}
          editable={editable}
          onAppointmentClick={handleAppointmentClick}
          startTime={timeRange?.startTime}
          endTime={timeRange?.endTime}
          scrollToEventId="event-1"
          headerToolbar={editable}
          // 200px per provider: 2-3 fit the step, scrolling starts only beyond that
          columnMinWidth={200}
        />
      </div>
    </>
  );
}

export default AvailabilityGrid;
